const configBoardFilter = {
    homeNews: {
        getFunc: 'getMainNews',
        listApiParamSet: {
            nof: 'NoticeFile',
        },
    },
    homeDonate: {
        getFunc: 'getMainDonate',
        listApiParamSet: {
            nof: 'NoticeFile',
        },
    },
    news: {
        getFunc: 'getNews',
        listApiParamSet: {
            type: 'post',
            f: 'File',
            ip: 1,
            obt: 'wr_datetime',
            obs: 'DESC',
        },
        pageRow: 5,
    },
    donate: {
        getFunc: 'getDonate',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
            imf: 'ImportantFile',
            obt: 'wr_datetime',
            obs: 'DESC',
        },
        pageRow: 10,
    },
    business: {
        getFunc: 'getBusiness',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
            obt: 'wr_datetime',
            obs: 'DESC',
        },
        pageRow: 5,
    },
    album: {
        getFunc: 'getAlbum',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
            obt: 'wr_datetime',
            obs: 'DESC',
        },
        pageRow: 10,
    },
    financial: {
        getFunc: 'getFinancial',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
            obt: 'wr_datetime',
            obs: 'DESC',
        },
        pageRow: 10,
    },
    newsDetail: {
        getFunc: 'getNews',
        detailApiParamSet: {
            type: 'post',
        },
    },
    businessDetail: {
        getFunc: 'getBusiness',
        detailApiParamSet: {
            type: 'post',
        },
    },
    financialDetail: {
        getFunc: 'getFinancial',
        detailApiParamSet: {
            type: 'post',
        },
    },
    donateDetail: {
        getFunc: 'getDonate',
        detailApiParamSet: {
            type: 'post',
        },
    },
    donatePrimeDetail: {
        getFunc: 'getDonatePrime',
        detailApiParamSet: {
            type: 'post',
        },
    },
    albumDetail: {
        getFunc: 'getAlbum',
        detailApiParamSet: {
            type: 'post',
        },
    },
    primeDonate: {
        getFunc: 'getDonatePrime',
        listApiParamSet: {
            imf: 'ImportantFile',
        },
    },
    newsSearch: {
        getFunc: 'getNews',
        listApiParamSet: {
            type: 'post',
            f: 'File',
            ip: 1,
        },
        pageRow: 5,
    },
    donateSearch: {
        getFunc: 'getDonate',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
            imf: 'ImportantFile',
        },
        pageRow: 5,
    },
    businessSearch: {
        getFunc: 'getBusiness',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
        },
        pageRow: 5,
    },
    albumSearch: {
        getFunc: 'getAlbum',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
        },
        pageRow: 5,
    },
    financialSearch: {
        getFunc: 'getFinancial',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
        },
        pageRow: 5,
    },

}

export default {
    methods: {
        returnBoardFilterConfig(type) {
            return configBoardFilter[type];
        }
    },
    filterConfig: {
        su: {
            type: 'query',
            classname: 'filterSearch'
        }
    }
}
